import { Routes } from '@angular/router';

import { RouteGuard } from './common/services/authentication/auth-guard.service';

export const routes: Routes = [
    { path: '', redirectTo: 'PST', pathMatch: 'full' },
    { path: 'login', loadChildren: () => import('./login/login.routing.module') },
    { path: 'PST', loadChildren: () => import('./platform/platform.routing.module'), canMatch: [RouteGuard] },
    { path: '**', redirectTo: 'PST' },
];
